import { fetchApiData } from "../../utils/apiUtils";
import { ENDPOINT } from "../../constants/api";
import * as kitchenSlice from "../slices/kitchen.slice";
const jsonData = [
  {
    id: 1,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A13",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 2,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 2,
    tableNo: "A14",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้ง",
    details: {
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 3,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 3,
    tableNo: "A14",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "Vegan พิซซ่าสำหรับคนทานมัง",
    details: {
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 4,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A03",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 5,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 3,
    tableNo: "A05",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 6,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 2,
    tableNo: "A06",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: false,
    },
  },
  {
    id: 7,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A13",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
  {
    id: 8,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A14",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้งข้าวผัดกุ้ง",
    details: {
      addOnList: ["เพิ่มกุ้ง"],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
  {
    id: 9,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A14",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "Vegan พิซซ่าสำหรับคนทานมัง",
    details: {
      addOnList: ["เพิ่มกุ้ง", "เพิ่มผัก"],
      ignoreList: [],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
  {
    id: 10,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A03",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
  {
    id: 11,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A03",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
  {
    id: 12,
    date: "19/09/2023 12:12",
    orderCode: "2020052510101",
    orderType: 1,
    tableNo: "A03",
    queue: "A0102",
    unit: 1,
    image: "/img/product/img3.png",
    name: "ข้าวผัดกุ้ง",
    details: {
      addOnList: [],
      ignoreList: ["ไม่เผ็ด"],
    },
    timeServ: {
      pos: "POS1",
      orderNo: "2020052510101",
      time: "16.30 น.",
      isCancel: true,
    },
  },
];
export const getKitchenTableData = () => async (dispatch) => {
  const data = jsonData;
  if (data) {
    dispatch(kitchenSlice.clearDataTable());
    dispatch(kitchenSlice.setDataTable(data));
    return data;
  }
};
export const getKitchenCard =
  (businessSlug, branchId, branchKitchenId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "GET",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order`,
      params: {
        branchId: branchId,
        branchKitchenId: branchKitchenId,
      },
      dispatch,
    });
    if (data) {
      dispatch(kitchenSlice.clearKitchenCard());
      dispatch(kitchenSlice.setKitchenCard(data));
      return data;
    }
  };
export const handleServOrderIndex = (index) => async (dispatch) => {
  console.log("Serving order index", index);
  dispatch(kitchenSlice.removeOrderItems(index));
};
export const removeCard = (index) => async (dispatch) => {
  dispatch(kitchenSlice.removeCard(index));
};
export const updateOrderItems = (value) => async (dispatch) => {
  dispatch(kitchenSlice.updateOrderItems(value));
};
export const handleCompleteOrderItem =
  (businessSlug, id) => async (dispatch) => {
    const response = await fetchApiData({
      method: "PUT",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order/per-order-item/${id}/completed`,
      dispatch,
    });
    if (response) {
      return response;
    }
  };
export const handleCancelingOrderItem =
  (businessSlug, data, id) => async (dispatch) => {
    const response = await fetchApiData({
      method: "PUT",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order/per-order-item/${id}/cancel`,
      data: Number(data?.quantity_removed_append) === 0 ? null : data,
      dispatch,
    });
    if (response) {
      return response;
    }
  };

export const getKitchenHistory =
  (businessSlug, s, branchPosId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order-transaction/pagination/${branchPosId}/list`,
      dispatch,
      params: {
        statusKitchen: s.statusKitchen === "" ? "SUCCESS" : s.statusKitchen,
        date: s.date,
        page: s.page,
        perPage: s.perPage,
        s: s.search,
        sortBy: s.sortBy,
        sortOrder: s.sortOrder,
        orderType: s.orderType === "" ? null : s.orderType,
      },
    });
    if (data) {
      dispatch(kitchenSlice.clearDataTable());
      dispatch(kitchenSlice.setDataTable(data));
    }
  };

export const completedAllOrder =
  (businessSlug, id, data) => async (dispatch) => {
    const response = await fetchApiData({
      method: "put",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order/order-item/${id}/complete`,
      dispatch,
      data: data,
    });
    if (response) {
      return response;
    }
  };
export const cancelAllOrder = (businessSlug, id, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "put",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/kitchen-order/order-item/${id}/cancel`,
    dispatch,
    data: data,
  });
  if (response) {
    return response;
  }
};
export const loginKitchen = (businessSlug, kitchenID) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/branch-kitchen/login`,
    dispatch,
    data: {
      branch_kitchen_id: kitchenID,
    },
  });
  if (response) {
    return response;
  }
};
export const logoutKitchen = (businessSlug, kitchenID) => async (dispatch) => {
  const response = await fetchApiData({
    method: "post",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/branch-kitchen/logout`,
    dispatch,
    data: {
      branch_kitchen_id: kitchenID,
    },
  });
  if (response) {
    return response;
  }
};

export const getKitchenTimer =
  (businessSlug, branchID, kitchenID) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order/summary`,
      dispatch,
      params: {
        branchId: branchID,
        branchKitchenId: kitchenID,
      },
    });
    return data;
  };

export const handleSocketResponse =
  (msg, isOrder = false) =>
  async (dispatch) => {
    if (isOrder) {
      await dispatch(
        kitchenSlice.setOrderSocket({ ...msg, timestamp: Date.now() })
      );
    } else {
      await dispatch(
        kitchenSlice.setKitchenSocket({ ...msg, timestamp: Date.now() })
      );
    }
  };
export const handleNotificationSocketResponse = (msg) => async (dispatch) => {
  console.log('[notification] raw msg:', msg, '| type:', typeof msg);
  // [fix] API sends JSON.stringify() — parse before spread, else string spreads char-by-char
  let parsed = msg;
  if (typeof msg === 'string') {
    try { parsed = JSON.parse(msg); } catch { parsed = { raw: msg }; }
  }
  console.log('[notification] parsed:', parsed);
  await dispatch(
    kitchenSlice.setNotificationSocket({ ...parsed, timestamp: Date.now() })
  );
};
export const notification = (businessSlug, id) => async (dispatch) => {
  const data = await fetchApiData({
    method: "get",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/kitchen-order-transaction`,
    dispatch,
    params: {
      branchPosSellingId: id,
    },
  });
  if (data) {
    dispatch(kitchenSlice.clearNotification());
    dispatch(kitchenSlice.setNotification(data));
  }
};
export const getTotalUnreadCount =
  (businessSlug, posId) => async (dispatch) => {
    const data = await fetchApiData({
      method: "get",
      endpoint: `${ENDPOINT.POS.replace(
        "{businessSlug}",
        businessSlug
      )}/kitchen-order-transaction/unread`,
      params: {
        branchPosSellingId: posId,
      },
      dispatch,
      dismissLoading: true,
    });

    if (!isNaN(data)) {
      await dispatch(kitchenSlice.setNotificationCount(0));
      await dispatch(kitchenSlice.setNotificationCount(data));
    }
  };
export const updateMessageToRead = (businessSlug, data) => async (dispatch) => {
  const response = await fetchApiData({
    method: "put",
    endpoint: `${ENDPOINT.POS.replace(
      "{businessSlug}",
      businessSlug
    )}/kitchen-order-transaction/unread`,
    data: data,
    dispatch,
    dismissLoading: true,
  });
  return response;
};
